import { Reveal } from "@/components/Reveal";
import { ASSETS } from "@/lib/site";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden border border-slate-200 shadow-lg">
              <img
                src={ASSETS.aboutBlueprint}
                alt="Architectural blueprint floor plan"
                className="w-full h-[340px] md:h-[440px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/40 to-transparent" />
            </div>
          </Reveal>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <Reveal>
              <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-blue">
                About us
              </p>
              <h2 className="mt-4 font-heading font-700 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-navy">
                A boutique SaaS developer focused on the construction sector
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-slate-600">
                Blue Shuck Consulting LTD is based in the North East of England
                and focuses on building software for construction SMEs. We
                combine product thinking with specialist development capability
                to create practical digital solutions that solve real business
                problems.
              </p>
              <p className="mt-4 text-lg leading-relaxed text-slate-600">
                Our approach is straightforward: build useful software, keep it
                focused, and deliver tools that are relevant to the way
                construction businesses actually operate.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
